import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue, useEffect } from "react";
import { warning } from "@lilib/utils";
import useUpdate from "./useUpdate";
import usePersist from "./usePersist";
import useSafeState from "./useSafeState";
import { useCacheConfig } from "./configs/CacheConfig";
function useCache(key) {
  var _options$cache, _options$cacheTime, _options$cacheSync;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = useCacheConfig();
  var defaultValue = options.defaultValue,
    validate = options.validate,
    onSet = options.onSet,
    onDelete = options.onDelete;
  var cache = (_options$cache = options.cache) !== null && _options$cache !== void 0 ? _options$cache : config.cache;
  var cacheTime = (_options$cacheTime = options.cacheTime) !== null && _options$cacheTime !== void 0 ? _options$cacheTime : config.cacheTime;
  var cacheSync = (_options$cacheSync = options.cacheSync) !== null && _options$cacheSync !== void 0 ? _options$cacheSync : config.cacheSync;
  var cacheSyncOnSet = false;
  var cacheSyncOnDelete = false;
  if (cacheSync === true) {
    cacheSyncOnSet = true;
    cacheSyncOnDelete = true;
  } else if (cacheSync) {
    cacheSyncOnSet = !!cacheSync.set;
    cacheSyncOnDelete = !!cacheSync["delete"];
  }
  var getCachedData = function getCachedData() {
    var cachedData = cache.get(key);
    if (cachedData !== undefined) {
      if (validate) {
        return validate(cachedData) ? cachedData : defaultValue;
      } else {
        return cachedData;
      }
    } else {
      return defaultValue;
    }
  };
  var _useSafeState = useSafeState(getCachedData),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    value = _useSafeState2[0],
    setValue = _useSafeState2[1];
  var setCache = usePersist(function (newValue) {
    if (newValue === undefined) {
      cache["delete"](key);
    } else {
      cache.set(key, newValue, {
        cacheTime: cacheTime
      });
    }
  });
  var shouldHandleSet = !!onSet || cacheSyncOnSet;
  var shouldHandleDelete = !!onDelete || cacheSyncOnDelete;
  var handleSet = usePersist(function (data) {
    if (cacheSyncOnSet) {
      setValue(getCachedData());
    }
    if (onSet) {
      onSet(data);
    }
  });
  var handleDelete = usePersist(function (data) {
    if (cacheSyncOnDelete) {
      setValue(getCachedData());
    }
    if (onDelete) {
      onDelete(data);
    }
  });
  useEffect(function () {
    if (shouldHandleSet) {
      cache["for"](key).on("set", handleSet);
      return function () {
        cache["for"](key).off("set", handleSet);
      };
    }
  }, [key, cache, shouldHandleSet, handleSet]);
  useEffect(function () {
    if (shouldHandleDelete) {
      cache["for"](key).on("delete", handleDelete);
      return function () {
        cache["for"](key).off("delete", handleDelete);
      };
    }
  }, [key, cache, shouldHandleDelete, handleDelete]);
  useUpdate(function () {
    setValue(getCachedData());
  }, [key, cache]);
  useUpdate(function () {
    if (process.env.NODE_ENV !== "production") {
      warning(true, "You should provide an immutable value for the `key` option.", {
        scope: "useCache"
      });
    }
  }, [key]);
  useDebugValue(value);
  return [value, setCache];
}
export default useCache;